import { getErrorMessage } from '@fruitful/fruitils';
import { CheckIcon, CircleAlertIcon, Icon, View } from 'smoothie';

export const MutationSuccessToastOptions = {
    duration: 2000,
    icon: (
        <View backgroundColor="$green300" padding={8} borderRadius={4}>
            <Icon icon={CheckIcon} color="$green1100" />
        </View>
    ),
};

export const MutationErrorToastOptions = (description?: unknown) => ({
    duration: 2000,
    description:
        description == null
            ? 'Reach out to engineering for support.'
            : typeof description === 'string'
              ? description
              : getErrorMessage(description),
    icon: (
        <View backgroundColor="$red100" padding={8} borderRadius={4}>
            <Icon icon={CircleAlertIcon} color="$red800" />
        </View>
    ),
});
